/**
 * @copyright © Paramount Streaming
 * @author  Daniel Silva
 * @description Reasons for playback interrupt request
 */

export enum VideoInterruptType {
	// If interrupt request is received during ad playback, stop playback after ad break is finished
	STOP_CONTENT_AFTER_AD = 'VideoInterruptType.STOP_CONTENT_AFTER_AD',

	// If interrupt request is received for multi stream plugin, stop playback
	STOP_CONTENT_MULTI_STREAM = 'VideoInterruptType.STOP_CONTENT_MULTI_STREAM',
}